// LUMINA · pages/vajra/components/LineageCard.jsx
// Phase 39D: extracted from VajraPortal.jsx

import React, { useState } from 'react';

export default function LineageCard({ lineage, member, setTab, teaching }) {
  const [open, setOpen] = useState(false);
  const hasInit = lineage.initiation_key
    ? (member?.initiations||[]).includes(lineage.initiation_key)
    : true;

  return (
    <div style={{
      border:`1px solid ${lineage.border}`,borderRadius:14,
      marginBottom:18,overflow:"hidden",
      boxShadow:open?"0 4px 20px rgba(0,0,0,0.08)":"none",
      transition:"box-shadow .3s",
    }}>
      {/* Card Header */}
      <div
        onClick={()=>setOpen(v=>!v)}
        style={{
          background:open?`linear-gradient(135deg,${lineage.bg},rgba(255,255,255,0))`:lineage.bg,
          padding:"18px 20px",cursor:"pointer",
          display:"flex",gap:16,alignItems:"center",
        }}
      >
        <div style={{
          width:52,height:52,borderRadius:"50%",flexShrink:0,
          background:`linear-gradient(135deg,${lineage.color}22,${lineage.color}0a)`,
          border:`1px solid ${lineage.color}44`,
          display:"flex",alignItems:"center",justifyContent:"center",
          fontSize:26,
        }}>{lineage.avatar}</div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
            <span style={{fontSize:17,color:"#1a1a1a",fontWeight:600,fontFamily:"'Noto Serif SC',serif"}}>{lineage.name_zh}</span>
            <span style={{fontSize:10,color:lineage.color,border:`1px solid ${lineage.color}44`,borderRadius:10,padding:"1px 8px",letterSpacing:.5}}>{lineage.tradition}</span>
          </div>
          <div style={{fontSize:11,color:"#888",marginTop:3,letterSpacing:.3}}>{lineage.name_en}</div>
          <div style={{fontSize:12,color:lineage.color,marginTop:4,fontWeight:500}}>
            上师：{lineage.teacher}
          </div>
        </div>
        <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:6,flexShrink:0}}>
          {hasInit && (
            <span style={{fontSize:10,color:lineage.color,background:`${lineage.color}12`,
              border:`1px solid ${lineage.color}33`,borderRadius:10,padding:"2px 10px"}}>
              ✓ 已受传承
            </span>
          )}
          <span style={{color:"#ccc",fontSize:13}}>{open?"▲":"▼"}</span>
        </div>
      </div>

      {/* Expanded Content */}
      {open && (
        <div style={{padding:"20px 22px",background:"#fff",borderTop:`1px solid ${lineage.border}`}}>
          {!hasInit && (
            <div style={{
              background:"rgba(0,0,0,0.03)",border:"1px solid rgba(0,0,0,0.08)",
              borderRadius:10,padding:"18px 20px",marginBottom:18,textAlign:"center",
            }}>
              <div style={{fontSize:22,marginBottom:8}}>🔒</div>
              <div style={{fontSize:13,color:"#666",lineHeight:1.7,marginBottom:12}}>
                此传承资料仅对已受相关灌顶的道友开放。<br/>
                如您已获此灌顶，请联系员工台进行认证。
              </div>
              <div style={{fontSize:11,color:"#aaa",letterSpacing:.3}}>
                请求认证 → 进入"员工台"或联系组织者
              </div>
            </div>
          )}

          {/* Intro */}
          <p style={{fontSize:13,color:"#444",lineHeight:1.85,margin:"0 0 18px",fontFamily:"'Noto Serif SC',serif"}}>
            {lineage.intro}
          </p>

          {/* Practices */}
          <div style={{marginBottom:18}}>
            <div style={{fontSize:10,color:lineage.color,letterSpacing:1.5,textTransform:"uppercase",marginBottom:8}}>修持法门</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
              {lineage.practices.map((p,i)=>(
                <span key={i} style={{
                  fontSize:12,color:lineage.color,
                  background:`${lineage.color}0a`,
                  border:`1px solid ${lineage.color}22`,
                  borderRadius:20,padding:"4px 12px",
                }}>{p}</span>
              ))}
            </div>
          </div>

          {/* Mantra Box */}
          <div style={{
            background:`linear-gradient(135deg,${lineage.color}08,${lineage.color}03)`,
            border:`1px solid ${lineage.color}22`,
            borderRadius:10,padding:"14px 16px",marginBottom:14,
          }}>
            <div style={{fontSize:10,color:"#aaa",letterSpacing:1.2,marginBottom:6}}>根本咒</div>
            <div style={{fontSize:14,color:lineage.color,letterSpacing:1.5,fontFamily:"'Noto Serif SC',serif",lineHeight:1.8,marginBottom:4}}>
              {lineage.mantra}
            </div>
            <div style={{fontSize:11,color:"#999"}}>{lineage.mantra_note}</div>
          </div>

          {/* Note */}
          <div style={{fontSize:12,color:"#999",lineHeight:1.7,fontStyle:"italic",borderLeft:`3px solid ${lineage.color}33`,paddingLeft:12}}>
            {lineage.note}
          </div>

          {/* Phase 40 F3D: link to standalone teaching detail page */}
          {teaching && (
            <div style={{ marginTop:10, paddingTop:10, borderTop:`1px solid ${lineage.color}18` }}>
              <button
                onClick={() => window.location.href = `/teaching/${teaching.id}`}
                style={{ fontSize:11, color:lineage.color, background:"none",
                  border:`1px solid ${lineage.color}33`, borderRadius:6,
                  padding:"4px 12px", cursor:"pointer" }}>
                查看法教详情 →
              </button>
            </div>
          )}

          {/* Phase 31: stage path (read-only) */}
          {teaching?.stages?.length > 0 && (
            <div style={{marginTop:14,paddingTop:14,borderTop:`1px solid ${lineage.color}18`}}>
              <div style={{fontSize:10,color:lineage.color,letterSpacing:1.5,textTransform:"uppercase",marginBottom:8}}>修行路径</div>
              <div style={{display:"flex",flexWrap:"wrap",alignItems:"center",gap:4}}>
                {teaching.stages.map((s,i)=>(
                  <React.Fragment key={s.id}>
                    {i>0&&<span style={{color:"#ccc",fontSize:11}}>→</span>}
                    <span style={{fontSize:12,color:lineage.color,background:`${lineage.color}08`,
                      border:`1px solid ${lineage.color}22`,borderRadius:16,padding:"3px 10px"}}>
                      {s.name_zh}
                    </span>
                  </React.Fragment>
                ))}
              </div>
            </div>
          )}

          {hasInit && (
            <div style={{marginTop:14,paddingTop:14,borderTop:`1px solid ${lineage.color}18`}}>
              <div style={{fontSize:11,color:lineage.color,letterSpacing:1.2,marginBottom:10,textTransform:"uppercase"}}>
                ✓ 已受传承 · 资料解锁
              </div>
              <button
                onClick={()=>{ if(setTab) setTab("teachings"); }}
                style={{
                  padding:"8px 20px",borderRadius:8,
                  border:`1px solid ${lineage.color}44`,
                  background:`${lineage.color}0a`,
                  color:lineage.color,
                  fontSize:12,cursor:"pointer",letterSpacing:.5,
                }}>
                查看相关修行资料 →
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
